module.exports = __webpack_public_path__ + "img/icon-refresh.d521b632.png";